var _style, _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInTimeLinkGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 798.3 195.2",
    style: {
      enableBackground: "new 0 0 798.3 195.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#58595B;}\n\t.st1{fill:url(#SVGID_1_);}\n")), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M711.6,36.5c-0.6,2-1.9,3.2-3.6,3.2c-2.1,0-3.3-1.5-2.6-4.2L714,3.4c0.5-2,1.9-3.2,3.6-3.2 c2.1,0,3.3,1.5,2.6,4.2L711.6,36.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M726.8,36.5c-0.6,2-1.9,3.2-3.6,3.2c-2.1,0-3.3-1.5-2.6-4.2l5.8-21.4c0.5-2.1,1.9-3.3,3.6-3.3 c2.2,0,3.3,1.6,2.6,4.2L726.8,36.5z M731.8,7.2c-2.1,0-3.6-1.3-3.2-3l0.2-0.6c0.4-1.9,2.1-3,4.2-3c2.1,0,3.5,1.3,3.2,3.1L736,4.3 C735.5,6,733.8,7.2,731.8,7.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M747.8,13.7l-0.3,1.1c2.2-2.2,5-4.2,8.6-4.2c5.2,0,8.6,3.3,8.6,8.5c0,1.5-0.4,3.3-0.9,5l-3.3,12.5 c-0.5,2-1.9,3.2-3.6,3.2c-2.1,0-3.3-1.5-2.6-4.2l3.2-11.8c0.3-0.9,0.4-2,0.4-2.8c0-2.8-1.8-4.4-4.9-4.4c-3.6,0-6.6,2.9-7.7,7.1 l-3.5,12.9c-0.5,2-1.9,3.2-3.6,3.2c-2.1,0-3.3-1.5-2.6-4.2l5.7-21.4c0.5-2.1,1.9-3.3,3.7-3.3C746.9,10.9,747.9,12.2,747.8,13.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M778.2,23.7l14.9-11.6c0.8-0.6,1.5-1.2,2.5-1.2c1.6,0,2.7,1.1,2.7,2.6c0,0.9-0.5,1.8-1.2,2.2l-9.7,7.4 l5.2,11.4c0.4,0.9,0.6,1.5,0.6,2.2c0,1.9-1.7,2.9-3.4,2.9c-1.8,0-2.8-1-3.3-2.3l-4.8-10.2l-5.6,4.3l-1.3,5c-0.5,2-1.9,3.2-3.6,3.2 c-2.1,0-3.3-1.5-2.6-4.2l8.7-32.2c0.5-2,1.9-3.2,3.6-3.2c2.1,0,3.3,1.5,2.6,4.2L778.2,23.7z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 743.8729,
    cy: 60.6769,
    r: 551.8038,
    gradientTransform: "matrix(1 0 0 -1 0 248.8)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#42B690"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5912,
    style: {
      stopColor: "#42B690"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7795,
    style: {
      stopColor: "#31AC94"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1CA698"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M228.6,83.7c1.6-7.6,8.9-13.6,16.4-13.6h2.8c6.5,0,9.7,3.2,12.4,7.9l37.7,68.6l13.5-63.5 c1.6-7.4,8.8-13.4,16.2-13.4c7.4,0,12.1,6,10.5,13.4l-20.8,98c-1.6,7.6-8.9,13.6-16.4,13.6H300c-6.5,0-9.7-3.2-12.4-7.9l-39.1-71.1 l-14,66c-1.6,7.4-8.8,13.4-16.2,13.4c-7.4,0-12.1-6-10.5-13.4L228.6,83.7z M393.8,95.9h-26c-6.9,0-11.3-5.6-9.8-12.5 s8.3-12.5,15.1-12.5h79.2c6.9,0,11.3,5.6,9.8,12.5s-8.3,12.5-15.2,12.5h-26l-18.2,85.7c-1.6,7.6-8.9,13.6-16.4,13.6 c-7.6,0-12.3-6-10.7-13.5L393.8,95.9z M483,83.4c1.6-7.6,8.9-13.6,16.4-13.6s12.3,6,10.7,13.5l-20.9,98.2 c-1.6,7.6-8.9,13.6-16.4,13.6c-7.6,0-12.3-6-10.7-13.5L483,83.4z M540.8,83.7c1.6-7.6,8.9-13.6,16.4-13.6h3c5.8,0,9.2,3,10.8,7 l21.4,53.3l44.3-53.5c3.8-4.6,8.1-6.9,13.6-6.9h3c7.6,0,12.3,6,10.7,13.5l-20.8,97.8c-1.6,7.6-8.9,13.6-16.4,13.6 c-7.4,0-12.1-6.2-10.5-13.5l13.1-61.4l-31.5,36.6c-3.7,4.2-7.8,6.9-12.7,6.9s-7.9-2.6-9.8-6.9l-15.7-36.1l-13,61.2 c-1.6,7.4-8.8,13.2-16.2,13.2s-12-5.8-10.4-13.2L540.8,83.7z M673,180.5l20.4-96.1c1.6-7.6,8.9-13.6,16.4-13.6h68.3 c6.7,0,11,5.5,9.6,12.1s-8,12-14.7,12h-54.9l-5.3,25h47c6.7,0,11,5.5,9.6,12.1c-1.4,6.7-8,12-14.7,12h-47l-5.5,25.9H758 c6.7,0,11,5.5,9.6,12.1c-1.4,6.7-8,12-14.7,12h-69.2C676.1,194,671.4,188.1,673,180.5z M73.2,158.4h15.2c5.2,0,10.3-4.2,11.4-9.4 l0,0c1.1-5.2-2.2-9.4-7.4-9.4H77.2c-5.2,0-10.3,4.2-11.4,9.4l0,0C64.7,154.1,68,158.4,73.2,158.4z M31.7,125.4H62 c5.2,0,10.3-4.2,11.4-9.4l0,0c1.1-5.2-2.2-9.4-7.4-9.4H35.7c-5.2,0-10.3,4.2-11.4,9.4l0,0C23.2,121.2,26.5,125.4,31.7,125.4z  M7.6,195.1h15.2c5.2,0,10.3-4.2,11.4-9.4l0,0c1.1-5.2-2.2-9.4-7.4-9.4H11.6c-5.2,0-10.3,4.2-11.4,9.4l0,0 C-0.9,190.9,2.4,195.1,7.6,195.1z M36.2,158.4h5.5c5.2,0,10.3-4.2,11.4-9.4l0,0c1.1-5.2-2.2-9.4-7.4-9.4h-5.5 c-5.2,0-10.3,4.2-11.4,9.4l0,0C27.7,154.1,31,158.4,36.2,158.4z M170.8,83.4c1.6-7.6,8.9-13.6,16.4-13.6c7.6,0,12.3,6,10.7,13.5 L177,181.5c-1.6,7.6-8.9,13.6-16.4,13.6H52.7c-4.5,0-7.4-3.6-6.4-8.1l0.6-2.8c1-4.5,5.4-8.1,9.9-8.1h86.6c4.8,0,9.4-4.1,10-8.9 c0.5-4.2-2.6-7.3-6.9-7.3H119c-4.5,0-7.4-3.6-6.4-8.1l0.6-2.8c1-4.5,5.4-8.1,9.9-8.1h27.8c4.8,0,9.4-4.1,10-8.9 c0.5-4.2-2.6-7.3-6.9-7.3H92.2c-4.5,0-7.4-3.6-6.4-8.1l0.6-2.8c1-4.5,5.4-8.1,9.9-8.1h62.1C168.3,105.2,170.8,83.4,170.8,83.4z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInTimeLinkGreen);
export default __webpack_public_path__ + "static/media/InTimeLink_green.3b60f5609319bb836e0907402a17e4e3.svg";
export { ForwardRef as ReactComponent };